import { useEffect, useRef } from "react";

import { onAppActive } from "src/hybrid/appLifecycle";

export const useRefreshOnAppVisible = (
  refresh: () => void | Promise<void>
): void => {
  const latestRefresh = useRef(refresh);
  latestRefresh.current = refresh;

  useEffect(() => {
    void latestRefresh.current();
    return onAppActive(() => void latestRefresh.current());
  }, []);
};

export default useRefreshOnAppVisible;
